"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegExp = void 0;
var misc_1 = require("./misc");
Object.defineProperty(exports, "escapeRegExp", { enumerable: true, get: function () { return misc_1.escapeRegExp; } });
//# sourceMappingURL=index.js.map